exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n[data-v-6094345c]:export {\n  xrColorPrimary: #2362FB;\n}\n.map[data-v-6094345c] {\n  height: 150px;\n  width: 100%;\n  overflow: hidden;\n  margin-top: 5px;\n}\n.area-title[data-v-6094345c] {\n  font-size: 12px;\n  color: #aaa;\n  padding-left: 10px;\n}\n", ""]);

// exports
